import React from 'react';
import { Route, Switch, Redirect } from "react-router"
import Login from './conteiners/Login'
import Step1 from './conteiners/Step1'
import Step2 from './conteiners/Step2'
import Step7 from './conteiners/Step7'
import Step9 from './conteiners/Step9'
import Step10 from './conteiners/Step10'
import Thank from './conteiners/Thank'
import Greeting from './conteiners/Greeting'
import Callback from './conteiners/Callback'
// import PageNotFound from './conteiners/PageNotFound'
import PageNotFound from './components/page404'

import withTracker from './utils/analytics'

export default (props) => {
    const {
        isLoggerdIn
    } = props

    const PrivateRoute = ({ component: Component, ...rest }) => (
        <Route
            {...rest}
            render={props =>
                isLoggerdIn ? (
                    <Component {...props} />
                ) : (
                        <Redirect
                            to={{
                                pathname: '/'
                            }}
                        />
                    )
            }
        />
    )

    return (
        <Switch>
            <Route exact path="/callback/:solicitudId" component={withTracker(Callback)} />
            <Route exact path="/404" component={withTracker(PageNotFound)} />
            {/* <Route exact path="/mariva/:monto?/:plazo?" component={Step1} /> */}
            <Route exact path="/:banco/login" component={withTracker(Login)} />
            <Route exact path="/:banco/step1" component={withTracker(Step2)} />
            <Route exact path="/:banco/step2" component={withTracker(Step7)} />
            <Route exact path="/:banco/step3" component={withTracker(Step9)} />
            <Route exact path="/:banco/step4" component={withTracker(Step10)} />
            <Route exact path="/:banco/greeting" component={withTracker(Greeting)} />
            <Route exact path="/:banco/thank" component={withTracker(Thank)} />
            <Route exact path="/:banco(credility|iaja|redcloud|columbia|bst|interfinanzas|ciudad|cmf|came|bacs|mills|acindarpymes|mariva|bvds|directo|comafi|celesol|bice)/:monto(\d+)?/:plazo(\d+)?" component={Step1} />
            <Route exact path="/" render={() => (<Redirect to="/credility" />)} />
            <Redirect to="/404" />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/routes.js